import { createContext } from "react";
import { TAppContext } from "types/app-context.type";

export const AppContext = createContext<TAppContext | undefined>(undefined);
